import gql from "graphql-tag";


export const GET_USERS = gql`
 query {
  users (order_by: {name: asc}){
    id
    name
    email
    mobile
    role
    password
    userCities{ userId city }
    isActive
    }
  roles{
    id
    name
   }
 }
`
export const GET_MAPPED_USERS = gql`
 query {
  users{
    id
    name
  }
 }
`
export const GET_USER_ROLES = gql`
 query {
  roles{
    id
    name
   }
 }
`

export const GET_USERCITIES = gql`
 query userCities($userId: uuid!){
  userCities (where: {userId: {_eq: $userId}}){
    userId
    city
    }
 }
`
